export default {
  TotalSize: 4,
  Size: 3,
  Type: 2,
  Custom: 1,
  TotalSizeToast: 5 // Hiển thị toast chứ không show confirm lỗi
};
